import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import React from "react";

const CpiIndexCellRenderer = (params: any) => {
  const { isOutright } = returnAllTradeDetailsFromGenericParams(params);

  function determineCPIValue() {
    if (isOutright) {
      return params.data?.legs?.[0]?.cpiIndex;
    }
    return params.value;
  }

  const valueToRender = determineCPIValue();

  return <div data-testid="CPIIndexCellRenderer">{valueToRender}</div>;
};

export default CpiIndexCellRenderer;
